export default __webpack_public_path__ + "static/media/coinbase.833f563a.svg";